import { z } from 'zod';
const stringToJsonSchema = z.string().transform((str, ctx) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
        return z.NEVER;
    }
});
export const overridesSchema = stringToJsonSchema.pipe(z.array(z.object({
    name: z.string(),
    enabled: z.boolean(),
    forUsers: z.array(z.string()).optional(),
})));
